export default __webpack_public_path__ + "static/g202-3759bd7845b2c7218bb0208b13d4ea64.jpg";